import { FC } from 'react';
import { Trans } from 'react-i18next';
import translation, { world } from '../../../../languages';
import { AVAILABLE_WORLDS } from '../../../../languages/constants';
import { useAppSelector } from '../../../../store';
import './marketplace-suggestion.scss';

const MarketplaceSuggestion: FC<TranslationProps> = ({ t }) => {
    const geotargeting = useAppSelector((state) => state.main.geotargeting);
    const countryCode = `${geotargeting.countryCode}`.toLowerCase();
    const isWorldSupported = Object.values(AVAILABLE_WORLDS).includes(countryCode as AVAILABLE_WORLDS);

    if (countryCode !== world && isWorldSupported) {
        const country = t(`common.worlds.${countryCode}.name`);
        const adjective = t(`common.worlds.${countryCode}.adjective`);

        return (
            // prettier-ignore
            <div className='marketplace-suggestion'>
                <Trans i18nKey='common.worldSwitch.browsingFrom' t={t}>
                    {/* @ts-ignore */}
                    You are browsing from <span>{{ country }}</span>. Do you want to visit <a className='highlighted-link green' href={`/${countryCode}`}>{{ adjective }} </a> <a className='highlighted-link green' href={`/${countryCode}`}>marketplace</a>?
                </Trans>
            </div>
        );
    }

    return null;
};

const translate = translation('common');

export default translate(MarketplaceSuggestion);
